import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ApprovalItemsPanelComponent } from "./approval-items-panel.component";
import { GridModule } from "src/app/_modules/modules/grid.module";
import { SharedModule } from "src/app/shared.module";

@NgModule({
    declarations: [ApprovalItemsPanelComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        GridModule,
        SharedModule
    ],
    exports: [ApprovalItemsPanelComponent]
})
export class ApprovalItemsPanelModule { }
